import { Divider, Typography } from "antd";
import React from "react";
import { Icon } from "../components/ui";
import "../styles/Agreement.scss";

const { Title, Paragraph, Link } = Typography;

const goBack = () => (window.history.length > 1 ? window.history.back() : window.location.assign("/"));

const UserPrivacyAgreement: React.FC = () => (
  <div className="agreement-page">
    <header className="agreement-page__bar">
      <a className="agreement-page__brand" href="/">
        <img src="/brand/duoduopin-mark-256.png" alt="" width={28} height={28} />
        <span>多多拼</span>
      </a>
      <button type="button" className="agreement-page__back" onClick={goBack}>
        <Icon name="arrowL" size={15} />返回
      </button>
    </header>
    <article className="agreement-page__doc">
    <Typography>
      <Title level={2}>多多拼用户协议与隐私说明</Title>
      <Paragraph type="secondary">更新日期：2026 年 9 月 22 日</Paragraph>
      <Paragraph>
        本说明适用于多多拼浏览器插件及其账号、任务管理服务。多多拼是面向拼多多商家的第三方运营工具，
        用于辅助已获授权的商家在商家后台执行商品操作、活动任务和查看执行记录。具体功能以产品中已开放的界面为准。
      </Paragraph>

      <Title level={3}>一、使用约定</Title>
      <Paragraph>
        请仅使用您本人或已获得管理授权的商家账号，并遵守商家平台的规则。提交商品修改、活动报名等操作前，
        请核对所选商品、规格、价格及活动条件。批量操作会影响真实店铺，您应在确认范围和参数后再执行。
        多多拼账号用于访问本产品，与您在拼多多的商家账号分别管理。
      </Paragraph>
      <Paragraph>
        部分功能需要有效的团队账号、邀请码、会员权限或足够的算力。功能是否可用、算力扣除和执行结果以界面提示及任务记录为准。
        平台页面或接口变化、网络异常可能导致任务失败；遇到异常请暂停并核对商家后台结果，避免重复执行。
      </Paragraph>

      <Divider />
      <Title level={3}>二、我们处理哪些信息</Title>
      <Paragraph><strong>账号与登录信息：</strong>您提交的手机号、验证码、账号标识、团队和权限信息，用于登录、权限校验及账号管理。
        如果您在支持密码的账号页面设置密码，服务端保存密码哈希用于验证。登录令牌用于后续请求认证。</Paragraph>
      <Paragraph><strong>商家页面与任务信息：</strong>启用插件并在支持的商家页面使用功能时，插件会处理页面及相关接口返回的商品、规格、价格、活动条件、店铺标识等内容。
        为建立任务、查询执行状态及计算算力，任务类型、相关商品或规格标识、执行参数、结果、错误说明和时间等必要信息会发送至多多拼 API。
        具体商品修改和报名请求由浏览器向拼多多商家平台发出。</Paragraph>
      <Paragraph><strong>本地数据：</strong>插件在浏览器扩展存储中保存登录状态、账号信息及功能所需的设置；页面操作还会使用当前浏览器中的商家登录会话。
        本地处理的数据同样属于本说明的范围。</Paragraph>
      <Paragraph><strong>服务运行与安全信息：</strong>多多拼服务端处理登录时间、请求 IP、客户端类型与版本等信息，用于登录记录、限制异常请求和排查服务故障。
        这些必要的服务记录与插件调试日志分开处理。</Paragraph>

      <Title level={3}>三、诊断日志与第三方服务</Title>
      <Paragraph>
        从浏览器插件 0.1.11 起，插件已移除旧版阿里云 SLS 远程调试日志上传。
        调试信息仅写入当前设备的开发者控制台，日志工具会遮盖手机号、令牌、密码等敏感字段。
        插件不会为了日志上报读取账号手机号，也不把这些调试日志发送给独立的第三方日志服务。
        旧版本请更新后再使用。
      </Paragraph>
      <Paragraph>
        账号和任务服务使用 Cloudflare Workers 与 D1 承载请求和数据；手机号及验证码短信所需信息由阿里云短信服务处理。
        拼多多商家平台处理您向其提交的店铺操作请求。这些服务按各自职责处理所需信息。
        浏览器商店和浏览器自身的数据处理适用对应厂商的隐私说明。
      </Paragraph>
      <Paragraph>
        我们仅将用户数据用于提供已说明的功能、账号安全和必要的服务维护，不出售用户数据，不用于个性化广告，
        不收集与商家功能无关的完整浏览历史。对通过浏览器扩展获得的数据，其使用和传输遵循 Chrome Web Store 用户数据政策中的 Limited Use 要求。
      </Paragraph>

      <Title level={3}>四、扩展权限为什么需要</Title>
      <ul>
        <li><strong>storage：</strong>保存本地登录状态、账号信息和功能设置。</li>
        <li><strong>tabs / activeTab：</strong>定位正在操作的商家页面、打开或管理执行任务所需的页面。</li>
        <li><strong>scripting：</strong>在已声明的商家页面运行随插件打包的功能脚本。</li>
        <li><strong>mms.pinduoduo.com：</strong>在拼多多商家后台展示辅助操作界面并执行您发起的任务。</li>
        <li><strong>api.ipin.work：</strong>完成多多拼账号认证、权限校验、任务管理和算力记录查询。</li>
      </ul>
      <Paragraph>您可以在浏览器扩展管理页面限制站点访问、停用或卸载插件。限制相关权限后，对应功能可能无法运行。</Paragraph>

      <Title level={3}>五、保存、退出与删除</Title>
      <Paragraph>
        账号、任务和算力记录保存在服务端，用于持续提供账号和任务查询服务；不会仅因关闭页面、退出登录或卸载插件而自动删除。
        短信验证码和图片验证码具有有效期。登录令牌保存在浏览器本地，退出账号会清除插件保存的认证状态。
      </Paragraph>
      <Paragraph>
        如需查询、更正、导出或申请删除账号与任务数据，请联系为您开通账号的团队管理员，由管理员核对账号及处理范围。
        处理申请时，应区分本机数据、团队共有记录、算力结算记录和服务端数据；需要保留的记录及原因会在处理申请时说明。
        不需要继续使用时，您可先退出账号，再通过浏览器扩展管理页面卸载。
      </Paragraph>

      <Title level={3}>六、安全与说明更新</Title>
      <Paragraph>
        多多拼 API 使用 HTTPS 传输，并通过登录令牌、团队权限和访问控制限制数据访问。请妥善保管账号、验证码和本机浏览器配置，
        不要向他人提供登录令牌。数据处理方式发生变化时，我们会更新本页面；涉及新的用途或权限时，将提供对应说明。
      </Paragraph>
      <Paragraph>产品入口：<Link href="https://www.ipin.work">https://www.ipin.work</Link>。账号与数据申请请通过为您开通账号的团队管理员联系。</Paragraph>
    </Typography>
    </article>
  </div>
);

export default UserPrivacyAgreement;
